import React, { useState } from 'react'
import qs from 'query-string'
import PropTypes from 'prop-types'
import { useMutation } from '@apollo/react-hooks'
import { useHistory, useLocation } from 'react-router-dom'
import ReactSVG from 'react-svg'

import Button from '../../../../../components/button'
import DELETE_NAMED_LIST from '../../../../../../graphql/mutations/delete-named-list.gql'
import arrowLeft from '../../../../../../images/arrow-left-light.svg'
import { getGQLErrorMsg } from '../../../../../lib/apollo'
import { STATIC_SCREENS } from '../../../../../constants'
import styles from './confirm-delete-list-modal.css'

/**
 * Confirm delete list modal
 *
 * Key features:
 * - Reads list context (`listName`, `listId`) from modal query params.
 * - Submits delete mutation and redirect to My Lists page on success.
 */
const ConfirmDeleteListModal = ({ onRequestClose }) => {
  const location = useLocation()
  const history = useHistory()
  const parsedSearch = qs.parse(location && location.search)
  const { listName, listId } = parsedSearch
  const [submitError, setSubmitError] = useState('')
  const [deleteList] = useMutation(DELETE_NAMED_LIST)
  const isSaveDisabled = !listId || !listName

  const onSubmit = async (data) => {
    try {
      await deleteList({
        variables: {
          id: listId
        }
      })
      setSubmitError('')
      // Close the modal and redirect to My Lists page
      history.push({
        pathname: STATIC_SCREENS.MY_LISTS.screenId,
        search: null
      })
    } catch (err) {
      setSubmitError(getGQLErrorMsg(err) || 'An error occurred while deleting the list. Please try again.')
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerWrapper}>
        <button
          type="button"
          onClick={onRequestClose}
          className={styles.iconButtonFrame}
          aria-label="Back"
        >
          <div className={styles.iconButton}>
            <ReactSVG
              src={arrowLeft}
              beforeInjection={(svg) => {
                svg.setAttribute('class', styles.icon)
              }}
            />
          </div>
        </button>
        <span className={styles.header}>
          Delete List?
        </span>
      </div>

      <div className={styles.content}>
        <span>
          Are you sure you want to delete your
          {' '}
          <span className={styles.listName}>{listName}</span>
          {' '}
          list?
        </span>
      </div>

      <div className={styles.buttonGroup}>
        <Button
          onClick={onRequestClose}
        >
          No, Keep List
        </Button>
        <Button
          onClick={onSubmit}
          disabled={isSaveDisabled}
          darkBGSecondary
        >
          Yes, Delete List
        </Button>
      </div>

      {submitError && (
        <div className={styles.warning}>
          {submitError}
        </div>
      )}
    </div>
  )
}

ConfirmDeleteListModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired
}

export default ConfirmDeleteListModal
